// extracted by mini-css-extract-plugin
export default {"titleWrapper":"_38902b0c","icon":"_894c01b4","text":"_e66b40e2","promoCode":"_86f187d"};